import StreamWorker from './StreamWorker.worker'
import { getNewStreamContext } from '../audio'
import { AudioCommand } from '../audio/AudioCommand'
import { DataCommand } from './DataCommand'
import loSto from '../config/loSto'
import { LO_STO } from '../lib/constants'
import { logger } from '../lib/logging'
import RecognitionStream from '../recognition/RecognitionStream'
import ActionStream from '../recognition/ActionStream'

const streamWorker = (function () {
  let instance = null

  function createInstance () {
    console.debug('start stream worker called %d time', ++times)
    const worker = new StreamWorker()
    console.debug('StreamWorker started')
    loSto.set(LO_STO.STREAM_INITIALIZED, true)

    const options = {
      objectMode: true,
      worker: worker
    }

    // Stream that is used to receive messages from the backend
    new RecognitionStream(options).pipe(new ActionStream(options), { end: false })

    worker.postMessage({
      cmd: DataCommand.INIT_SOCKET,
      origin: window.location.origin
    })
    // Register event handlers for incoming recognition results
    console.info('Starting stream worker & creating websocket pipeline...')

    // Keep checking for connectivity as long as stream worker is alive
    window.setInterval(checkConnectivity, 1000)

    // [TODO: IMPORTANT FUNCTION] Look into refactoring and re-enabling
    // Register listener on route location changes
    // console.debug('Registering route location watcher...')
    // registerLocationWatcher(streamWorker.get())
    return worker
  }

  return {
    get: function () {
      if (!instance) {
        instance = createInstance()
      }
      return instance
    }
  }
})()

let times = 0

export const getStreamWorker = () => {
  return streamWorker.get()
}

const checkConnectivity = () => {
  // Check for connectivity
  if (navigator.onLine) {
    streamWorker.get().postMessage({
      cmd: DataCommand.ONLINE
    })
  } else if (!navigator.onLine) {
    streamWorker.get().postMessage({
      cmd: DataCommand.OFFLINE
    })
  }
}

/** Convenience Functions */
export const sendSpeechConfig = (configReason) => {
  logger.info(`Sending speech configuration due to: ${configReason}`)

  const context = getNewStreamContext(false)
  if (!context.sessionOwnerId) {
    console.error('Client tried to send audioStream context with no sessionOwnerId. Naughty naughty.')
    logger.error('Client tried to send audioStream context with no sessionOwnerId.')
    return
  }

  if (context.path === '/note') {
    if (!context.noteId || !context.noteTypeId) {
      console.warn('Client tried sending audioStream context without noteId or noteTypeId while in note view. Dont send this speech_config.')
      return
    }
  }

  streamWorker.get().postMessage({
    cmd: AudioCommand.SPEECH_CONFIG,
    // pass new stream to be false, since we are just passing configuration around
    context: getNewStreamContext(false),
    configReason: configReason
  })
}
